import { Apple, ArrowUpRight, Play } from "lucide-react";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/constants/site";
import { Reveal } from "@/components/landing/Reveal";

export const FinalCTA = () => {
  return (
    <section className="bg-splurge-bg px-5 py-24 sm:px-8 lg:py-32">
      <Reveal className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-splurge-dark via-splurge-primary to-splurge-dark px-6 py-20 text-center shadow-2xl shadow-splurge-dark/30 sm:px-12 lg:py-28">
          <span
            aria-hidden="true"
            className="animate-drift pointer-events-none absolute -right-10 -top-24 select-none text-[16rem] font-extrabold leading-none text-white/[0.07] sm:text-[22rem]"
          >
            ₹
          </span>
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-splurge-violet/30 blur-3xl"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-16 left-1/3 hidden rotate-6 rounded-2xl border border-white/15 bg-white/[0.06] p-5 backdrop-blur-sm lg:block"
          >
            <p className="text-[11px] font-semibold text-white/50">Group settle</p>
            <p className="mt-1 text-sm font-extrabold text-white">All settled ✓</p>
          </div>

          <h2 className="relative mx-auto max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Know where your money goes.{" "}
            <span className="text-splurge-lavender">Keep living your life.</span>
          </h2>
          <p className="relative mx-auto mt-6 max-w-xl text-base text-white/70 md:text-lg">
            Free on iOS &amp; Android · Designed for students aged 13–25
          </p>
          <div className="relative mt-10 flex flex-col items-center justify-center gap-3.5 sm:flex-row">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-button"
              aria-label="Get Splurge free on the App Store (opens in a new tab)"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-extrabold text-splurge-dark shadow-xl transition-all duration-200 hover:-translate-y-0.5 hover:bg-splurge-lavender active:scale-95"
            >
              <Apple className="h-4 w-4" aria-hidden="true" />
              Download for iOS
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-android"
              aria-label="Get Splurge free on Google Play (opens in a new tab)"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/40 px-8 py-4 text-sm font-extrabold text-white transition-all duration-200 hover:-translate-y-0.5 hover:border-white hover:bg-white/10 active:scale-95"
            >
              <Play className="h-4 w-4" aria-hidden="true" />
              Download for Android
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
